import { useCpmsBoGetRevenueByThirdPartyEndpointQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import {
  ByThirdPartyEndpointCard,
  ByThirdPartyEndpointCardVariantEnum,
} from '../../components/by-third-party-endpoint-card/by-third-party-endpoint.card';
import { useFilters } from '../../context/filters.context';

export const RevenueByThirdPartyEndpointCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetRevenueByThirdPartyEndpointQuery({
    ...transformedFilters,
  });

  return (
    <ByThirdPartyEndpointCard
      data={data}
      variant={ByThirdPartyEndpointCardVariantEnum.Revenue}
    />
  );
};
